import { initializeApp } from 'firebase/app';
import { initializeAnalytics } from 'firebase/analytics';
import { getRemoteConfig, isSupported } from 'firebase/remote-config';
import logger from '~/utils/logger/logger';

const {
  FB_API_KEY,
  FB_PROJECT_ID,
  FB_MESSAGING_SENDER_ID,
  FB_APP_ID,
  FB_MEASUREMENT_ID,
  FB_AUTH_DOMAIN,
  FB_DATABASE_URL,
  FB_STORAGE_BUCKET,
  FB_APP_NAME,
} = process.env;

const firebaseConfig = {
  apiKey: FB_API_KEY,
  projectId: FB_PROJECT_ID,
  messagingSenderId: FB_MESSAGING_SENDER_ID,
  appId: FB_APP_ID,
  measurementId: FB_MEASUREMENT_ID,
  authDomain: FB_AUTH_DOMAIN,
  databaseURL: FB_DATABASE_URL,
  storageBucket: FB_STORAGE_BUCKET,
};

/** Whether the Firebase web config needed by Analytics and Remote Config is present. */
export const isFirebaseConfigured = Boolean(FB_API_KEY && FB_PROJECT_ID && FB_APP_ID);

export const firebaseApp = initializeApp(firebaseConfig, FB_APP_NAME || undefined);

if (isFirebaseConfigured) {
  try {
    initializeAnalytics(firebaseApp, {
      config: {
        send_page_view: false,
      },
    });
  } catch {
    logger.warn('Firebase analytics is not supported in this environment.');
  }
}

export const remoteConfig = async () =>
  isFirebaseConfigured && (await isSupported()) && getRemoteConfig(firebaseApp);
